import React, { useState, useEffect } from 'react'
import {
    useParams
} from 'react-router-dom'

export default (props) => {
    const {date} = useParams()
    const [picdet, setPicDet] = useState({})
    const [loading, setLoading] = useState(false)
    
    useEffect(()=>{
        console.log('masuk use effect')
        setLoading (true)
        let apiUrl = `https://api.nasa.gov/planetary/apod?api_key=qfu92Q3t1xBcZPHWCphiBhTZrqnB3KhQfsKNnbME&date=${date}`
            fetch(apiUrl)
            .then(resp => resp.json())
            .then(data=>{
                setPicDet(data)
            })
        setLoading(false)
    },[date])

    if (loading) return <p>Loading picture....</p>
    console.log('masuk child route')

    return (
        <>
            <hr/>
            <h2>Title: {picdet.title}</h2>
            <p>{picdet.date}</p>
            <p>{picdet.explanation}</p>
            <img src={ picdet.url } alt="nasa" id="img-detail"/> 
        </>
    )
}